export default {
    apiNameSpace: 'https://sc.tktine.xynest.cn/api'
}